<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>STEP<span>05</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>ショップのターゲットの年代を教えてください。</span></h3>
            </div>

            <!--item-->
            <div class="item-wrap">

                <div class="form_select-wrap _range _w100">

                    <div class="item form_select">
                        <select name="target-range" id="target-range-lower-limit">
                            <option value="10">10代</option>
                            <option value="20">20代</option>
                            <option value="30">30代</option>
                            <option value="40">40代</option>
                            <option value="50">50代</option>
                            <option value="60">60代</option>
                        </select>
                    </div>

                    <div class="item form_select">
                        <select name="target-range" id="target-range-upper-limit">
                            <option value="10">10代</option>
                            <option value="20">20代</option>
                            <option value="30">30代</option>
                            <option value="40">40代</option>
                            <option value="50">50代</option>
                            <option value="60">60代</option>
                        </select>
                    </div>

                </div>

            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next"><span>Next</span></button>
        </div>

    </div>
</div>
</template>

